import { render, staticRenderFns } from "./ContentSelectionAndTag.vue?vue&type=template&id=05532bf2&scoped=true&"
import script from "./ContentSelectionAndTag.vue?vue&type=script&lang=js&"
export * from "./ContentSelectionAndTag.vue?vue&type=script&lang=js&"
import style0 from "./ContentSelectionAndTag.vue?vue&type=style&index=0&id=05532bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05532bf2",
  null
  
)

export default component.exports